<template>
  <div>
    <button :class="{tiny: true, loading: buttonsLoading}"
            @click="goPrevPage"
            :disabled="isPrevDisabled"><i class="fa fa-arrow-left"></i> пред
    </button>
    <span v-for="row in paginationNumbers">
        <button v-if="row.text !== '...'"
                @click="goPage(row.value)"
                :class="{tiny: true, black: row.text == pagination.currentPage, loading: buttonsLoading}">
            {{ row.text }}
        </button>
        <select v-if="row.text === '...'"
                class="tiny button"
                @change="goPage(pageSelected)"
                v-model="pageSelected"
                :class="{'tiny button': true, blue: row.text == pagination.currentPage, loading: buttonsLoading}">
            <option disabled value="">.......</option>
            <option v-for="row in row.value" :value="row.value">{{ row.text }}</option>
        </select>
    </span>
    <button :class="{tiny: true, loading: buttonsLoading}"
            @click="goNextPage"
            :disabled="isNextDisabled">след <i class="fa fa-arrow-right"></i></button>
  </div>
</template>

<script>
export default {
  name: "DoctuTableLazyPagination",
  model: {
    prop: 'pagination',
    event: 'input'
  },
  props: {
    pagination: {
      required: true,
    },
    rowscount: {
      default: 0
    },
    pagesmax: {
      default: 100
    },
    isAsync: {
      default: false,
    },
  },
  data: function () {
    return {
      pageSelected: this.pagination.currentPage,
      disableButtons: false,
      buttonsLoading: false,
    }
  },
  computed: {
    isNextDisabled: function () {
      if (this.disableButtons) {
        return true;
      }

      if (typeof this.pagination.links !== 'undefined') {
        return this.pagination.links.next === null;
      } else {
        return this.pagination.total === false;
      }
    },
    isPrevDisabled: function () {
      return this.pagination.currentPage === 1 || this.disableButtons;
    },
    paginationNumbers: function () {
      let page;
      let result = [];
      if (this.pagination.totalPages === 1) {
        return [{text: 1, value: 1}];
      } else if (this.pagination.totalPages <= this.pagesmax) {
        for (page = 1; page <= this.pagination.totalPages; page++) {
          result.push({text: page, value: page});
        }
        return result;

      } else {

        let magicPagesmaxHalf = Math.ceil(this.pagesmax / 2);
        let pageOnStartOfButtons = this.pagination.currentPage <= magicPagesmaxHalf;
        let pageOnEndOfButtons = this.pagination.currentPage > (this.pagination.totalPages - magicPagesmaxHalf);
        if (pageOnStartOfButtons) {
          let maxPagesToShow = Math.min(this.pagesmax, this.pagination.totalPages);
          for (page = 1; page <= maxPagesToShow; page++) {
            result.push({text: page, value: page});
          }
        } else if (pageOnEndOfButtons) {
          let minPageTillEnd = Math.min(this.pagination.currentPage - magicPagesmaxHalf, this.pagination.totalPages - this.pagesmax) + 1;
          for (page = minPageTillEnd; page <= this.pagination.totalPages; page++) {
            result.push({text: page, value: page});
          }
        } else {
          for (page = Math.max(this.pagination.currentPage - magicPagesmaxHalf + 1, 1); page < Math.min(this.pagination.currentPage + magicPagesmaxHalf, this.pagination.totalPages); page++) {
            result.push({text: page, value: page});
          }
        }
        if (result[0].text !== 1) {
          let optionsBefore = [];
          for (let i = 2; i < result[2].text && i < 100; i++) {
            optionsBefore.push({text: i, value: i});
          }

          result[0] = {text: 1, value: 1};
          result[1] = {text: '...', value: optionsBefore};
        }

        if (result[result.length - 1].text !== this.pagination.totalPages) {
          let optionsAfter = [];
          for (let j = result[result.length - 3].text + 1; j < this.pagination.totalPages && j < 100; j++) {
            optionsAfter.push({text: j, value: j});
          }

          result[result.length - 2] = {text: '...', value: optionsAfter};
          result[result.length - 1] = {text: this.pagination.totalPages, value: this.pagination.totalPages};
        }
        return result;
      }
    },
  },
  methods: {
    goNextPage: function () {
      if (this.isNextDisabled) {
        return false;
      }
      let page = this.pagination.currentPage + 1;
      this.goPage(page);
    },

    goPrevPage: function () {
      if (this.isPrevDisabled) {
        return false;
      }
      let page = this.pagination.currentPage - 1;
      this.goPage(page);
    },

    goPage: function (page) {
      this.disableButtons = true;
      let pagination = JSON.parse(JSON.stringify(this.pagination));
      pagination.currentPage = page;
      if (this.isAsync && page > pagination.totalPages) {
          pagination.totalPages = page;
      }
      this.$emit('input', pagination);
    },
  }
}
</script>
